import * as React from 'react';

import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from 'src/utils';

const Progress = React.forwardRef<
    React.ElementRef<typeof ProgressPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, title, max, ...props }, ref) => (
    <ProgressPrimitive.Root
        ref={ref}
        className={cn('relative min-h-11 w-full overflow-hidden rounded-sm bg-gray-100', className)}
        {...props}
    >
        <div className="absolute z-30 flex h-full w-full items-center justify-between p-3">
            <span className={`text-xs font-medium ${value && value >= 20 && 'text-white'}`}>{title || '-'}</span>

            <span className="text-xs font-medium">{max || 0}</span>
        </div>
        <ProgressPrimitive.Indicator
            className="bg-primary h-full w-full transition-all"
            style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
    </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
